import React, { useEffect, useState, useTransition } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../../actions/baseActions";
import Breadcrumb from "../../../../../../components/Breadcrumb";
import Loading from "../../../../../../components/Loading";
import ProtectedRoute from "../../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../../components/SelectFilter";
import DataTable from "../../../../../../components/Tables/tables";
import URL from "../../../../../../config/api";
import axios from "../../../../../../config/axios";

const PartialProgressionGradeShow = props => {
  let [loading, setLoading] = useState();
  let [groupList, setGroupList] = useState();
  let [groupID, setGroupID] = useState(
    props.general.active_roles.group_id ?? null
  );

  let [regionList, setRegionList] = useState();
  let [regionID, setRegionID] = useState(
    props.general.active_roles.region_id ?? null
  );

  let [schoolList, setSchoolList] = useState();
  let [schoolID, setSchoolID] = useState(
    props.general.active_roles.school_id ?? null
  );

  let [classroomList, setClassroomList] = useState();

  let [trailList, setTrailList] = useState();
  let [trailID, setTrailID] = useState();

  let [trailLoading, setTrailLoading] = useState(false);
  let [usersTrailList, setUsersTrailList] = useState();

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        let group = props.general.active_roles.group_id ?? 0;
        let region = props.general.active_roles.region_id ?? 0;
        let school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(group, region);
          }
          if (school) {
            setSchoolID(school);
          }
        }

        await getTrails(group, region, school);
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/region/listRegionFilter/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const regionList = resp.data?.data.map(region => ({
            label: region.name,
            value: region.id
          }));
          setRegionList(regionList);
        });
    } catch {
      setRegionID(0);
      setSchoolID(0);
    }
  };

  const getSchools = async (groupID, id) => {
    if (!id) {
      setSchoolID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/school/listSchoolFilter/${groupID}/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const schoolList = resp.data?.data.map(school => ({
            label: school.name,
            value: school.id
          }));
          setSchoolList(schoolList);
        });
    } catch {
      setSchoolID(0);
    }
  };

  const getTrails = async (
    groupID = null,
    regionID = null,
    schoolID = null
  ) => {
    try {
      axios
        .get(
          `${URL.api}activity/trail_allocation/partial_progression/statistics/getTrailsByFilter`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` },
            params: {
              group_id: groupID,
              region_id: regionID,
              school_id: schoolID
            }
          }
        )
        .then(resp => {
          const trailList = resp.data?.data.map(trail => ({
            label: trail.name,
            value: trail.id
          }));
          setTrailList(trailList);
        });
    } catch {
      setTrailID(0);
    }
  };

  const getUserList = async () => {
    setTrailLoading(true);
    await axios
      .get(
        `${URL.api}activity/trail_allocation/partial_progression/usersGradesInTrail/${trailID}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` },
          params: {
            group_id: groupID,
            region_id: regionID,
            school_id: schoolID
          }
        }
      )
      .then(resp => {
        let userList = [];

        resp?.data.forEach(user => {
          let userData = {
            name: user.name,
            average: user.weighted_final_grade_average.toFixed(2),
            participation: `${user.completion_percentage_average.toFixed(2)}%`,
            step1: { try: 0 },
            step2: { try: 0 },
            step3: { try: 0 },
            step4: { try: 0 }
          };
          user?.evaluation_applications.forEach(evaluation => {
            switch (evaluation.step) {
              case 1:
                if (evaluation.try > userData.step1.try) {
                  userData.step1 = evaluation;
                  if (
                    userData.step1.processed === false &&
                    userData.step1.teacher_inserted === true
                  ) {
                    userData.step1.final_grade = "Em processamento";
                    userData.average = "Em processamento";
                  }
                }
                break;
              case 2:
                if (evaluation.try > userData.step2.try) {
                  userData.step2 = evaluation;
                  if (
                    userData.step2.processed === false &&
                    userData.step2.teacher_inserted === true
                  ) {
                    userData.step2.final_grade = "Em processamento";
                    userData.average = "Em processamento";
                  }
                }
                break;
              case 3:
                if (evaluation.try > userData.step3.try) {
                  userData.step3 = evaluation;
                  if (
                    userData.step3.processed === false &&
                    userData.step3.teacher_inserted === true
                  ) {
                    userData.step3.final_grade = "Em processamento";
                    userData.average = "Em processamento";
                  }
                }
                break;
              case 4:
                if (evaluation.try > userData.step4.try) {
                  userData.step4 = evaluation;
                  if (
                    userData.step4.processed === false &&
                    userData.step4.teacher_inserted === true
                  ) {
                    userData.step4.final_grade = "Em processamento";
                    userData.average = "Em processamento";
                  }
                }
                break;
            }
          });
          userList.push(userData);
        });
        userList = userList.map(user => ({
          ...user,
          step1: user.step1.final_grade
            ? `${user.step1.final_grade} (${user.step1.try}ª tentativa)`
            : "Avaliação não realizada",
          step2: user.step2.final_grade
            ? `${user.step2.final_grade} (${user.step2.try}ª tentativa)`
            : "Avaliação não realizada",
          step3: user.step3.final_grade
            ? `${user.step3.final_grade} (${user.step3.try}ª tentativa)`
            : "Avaliação não realizada",
          step4: user.step4.final_grade
            ? `${user.step4.final_grade} (${user.step4.try}ª tentativa)`
            : "Avaliação não realizada",
          result:
            user.average === "Em processamento"
              ? "Não definido"
              : user.average >= 6
              ? "Aprovado"
              : "Insuficiente"
        }));
        setUsersTrailList(userList);
        setTrailLoading(false);
      });
  };

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />
      <CCard>
        <CCardHeader>
          <CCardTitle>Visualização de Notas</CCardTitle>
          <CCardSubtitle className="small text-muted">
            Visualize as notas e participação nas trilhas em andamento
          </CCardSubtitle>
        </CCardHeader>
        <CCardBody>
          {loading ? (
            <Loading />
          ) : (
            <>
              <CCard className="d-flex justify-items-center justify-content-center p-4">
                <CRow>
                  <CCol sm="12" md="12">
                    <CRow>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Grupo"
                          icon="fa-users"
                          placeholder="Selecione um grupo"
                          value={groupID}
                          setFunction={async id => {
                            setGroupID(id);
                            getRegions(id);
                            await getTrails(id);
                          }}
                          options={groupList}
                          disabled={
                            !!props.general.active_roles.group_id || !trailID
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Regiões"
                          icon="fa-globe"
                          placeholder="Todas"
                          value={regionID}
                          setFunction={async id => {
                            setRegionID(id);
                            await getSchools(groupID, id);
                            await getTrails(groupID, id);
                          }}
                          options={regionList}
                          disabled={
                            !groupID || !!props.general.active_roles.region_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Escolas"
                          icon="fa-institution"
                          placeholder="Todas"
                          value={schoolID}
                          setFunction={async id => {
                            setSchoolID(id);
                            await getTrails(groupID, regionID, id);
                          }}
                          options={schoolList}
                          disabled={
                            !regionID || !!props.general.active_roles.school_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="4" className="my-2">
                        <SelectFilter
                          title="Trilha"
                          icon="fa-code-fork"
                          placeholder="Selecione uma trilha"
                          value={trailID}
                          setFunction={id => {
                            setTrailID(id);
                          }}
                          options={trailList}
                        />
                      </CCol>
                      <CCol
                        sm="12"
                        md="2"
                        className="d-flex justify-content-center my-2 align-items-end"
                      >
                        <CButton
                          color="primary"
                          className="d-flex justify-content-center align-items-center rounded-left w-100"
                          onClick={() => getUserList()}
                          disabled={!groupID || !trailID}
                        >
                          <i className="fa fa-filter" />
                          &nbsp; Filtrar
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCard>
              {usersTrailList ? (
                <>
                  <DataTable
                    noSort
                    list={usersTrailList}
                    title="Estudantes"
                    subtitle="Lista de estudantes participantes da trilha"
                    header={[
                      { name: "name", denomination: "Estudante" },
                      { name: "step1", denomination: "Passo 1" },
                      { name: "step2", denomination: "Passo 2" },
                      { name: "step3", denomination: "Passo 3" },
                      { name: "step4", denomination: "Passo 4" },
                      { name: "participation", denomination: "Participação" },
                      { name: "average", denomination: "Média Final" },
                      { name: "result", denomination: "Resultado" }
                    ]}
                  />
                </>
              ) : (
                <>
                  {!trailLoading ? (
                    <p className="w-100 text-center">
                      Selecione ao menos o grupo e uma trilha para obter o
                      resultado.
                    </p>
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </>
          )}
        </CCardBody>
        <ProtectedRoute routeId={props.currentRoute} />
      </CCard>
    </div>
  );
};

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

PartialProgressionGradeShow.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialProgressionGradeShow);
